import { useEffect, useState } from 'react'
import InvitationPopup, { Invitation } from './InvitationPopup';
import { useAuth } from '@/context/AuthContext';

export default function InvitationManager() {
  const [showPopup, setShowPopup] = useState(false);
  const [currentInvitation, setCurrentInvitation] = useState<Invitation | null>(null);
  const { pendingInvitations, checkPendingInvitations } = useAuth();

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleJoinSuccess = async (invitationId: string) => {
    console.log('Invitation joined:', invitationId);
    setShowPopup(false);
    await checkPendingInvitations();
  };

  const handleRejectSuccess = async (invitationId: string) => {
    console.log('Invitation rejected:', invitationId);
    setShowPopup(false);
    await checkPendingInvitations();
  };

  useEffect(() => {
    checkPendingInvitations();
  }, [checkPendingInvitations]);

  useEffect(() => {
    if (pendingInvitations.length > 0) {
      setCurrentInvitation(pendingInvitations[0]);
      setShowPopup(true);
    }
  }, [pendingInvitations]);

  return (
    <>
      {showPopup && (
        <InvitationPopup
          isOpen={showPopup}
          onClose={handleClose}
          invitation={currentInvitation}
          onJoinSuccess={() => handleJoinSuccess(currentInvitation.id)}
          onRejectSuccess={() => handleRejectSuccess(currentInvitation.id)}
        />
      )}
    </>
  );
}
